(function () {
    'use strict';
    var controllerId = 'stakAccettatoPopup';
    angular.module('app').controller(controllerId, ['$scope', '$filter', 'datacontext', '$uibModalInstance', 'test', stakAccettatoPopup]);

    function stakAccettatoPopup($scope, $filter, datacontext, $uibModalInstance, test) {
        $scope.record = test;
        $scope.voto = '';
        if ($scope.record.voto > 0)
            $scope.voto = $scope.record.voto;

        $scope.ok = function (isValid) {
            if (isValid) {
                $scope.record.voto = $scope.voto;
                $uibModalInstance.close($scope.record);
            }
        };

        $scope.cancel = function () {
            $uibModalInstance.dismiss('cancel');
        };
    }
})();